<template>
    <form class="form-inline mb-4">
        <input
            class="form-control w-25"
            autofocus
            type="search"
            placeholder="Buscar"
            @keyup.enter="doFilter"
            v-model="filterText"
            @click="resetFilter"
        >
        <button class="ml-2 btn btn-primary" @click.prevent="doFilter">Buscar</button>
    </form>
</template>

<script>
    export default {
        data () {
            return {
                filterText: ''
            }
        },
        methods: {
            doFilter () {
                this.$events.fire('filter-set', this.filterText)
            },
            resetFilter () {
                this.filterText = ''
                this.$events.fire('filter-reset')
            }
        }
    }
</script>